<template>
  <div>
    <p>Grupy
      <el-button type="primary" @click="dialogVisible = true">Dodaj grupę</el-button>
    </p>
    <template>
      <el-table :data="groups" style="width: 100%" stripe>
        <el-table-column prop="name" label="Nazwa grupy" sortable>
        </el-table-column>
        <el-table-column prop="description" label="Opis">
        </el-table-column>
        <el-table-column label="Opcje">
          <template slot-scope="scope">
            <el-button @click.native.prevent="deleteGroup(scope.$index, groups)" type="text" size="small">
              Usuń
            </el-button>
          </template>
        </el-table-column>

      </el-table>
    </template>

    <el-dialog title="Dodaj grupę" :visible.sync="dialogVisible" size="tiny">
      <span>

        <span class="my-label">Nazwa</span>
        <el-input placeholder="Nazwa grupy" v-model="group.name"></el-input>
        <span class="my-label">Opis</span>
        <el-input placeholder="Opis grupy" type="textarea" :rows="2" v-model="group.description"></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Anuluj</el-button>
        <el-button type="primary" @click="dialogVisible = false, addGroup()">Dodaj</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
import { serverAddress } from "../config";
export default {
  mounted: function() {
    this.getGroups("/api/groups");
  },
  data: function() {
    return {
      groups: [],
      group: {
        name: "",
        description: ""
      },
      dialogVisible: false
    };
  },
  methods: {
    handleCurrentChange(value) {
      this.currentRow = value;
    },
    getGroups(url) {
      axios
        .get(serverAddress + url, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            this.groups = response.data;
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error);
          }.bind(this)
        );
    },

    deleteGroup(index, rows) {
      axios
        .delete(serverAddress + "/api/groups/" + rows[index].name, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            rows.splice(index, 1);

            console.log(response);

            this.$message({
              message: "Pomyślnie usunięto grupę",
              type: "success"
            });
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error);
            this.$message({
              message: "Błąd usuwania grupy",
              type: "error"
            });
          }.bind(this)
        );
    },
    addGroup() {
      axios
        .post(serverAddress + "/api/groups", this.group, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            console.log(response);
            this.groups.push(this.group);

            (this.group = {
              name: "",
              description: ""
            }),
              this.$message({
                message: "Pomyślnie zapisano grupy",
                type: "success"
              });
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$message({
              message: "Błąd zapisu grup",
              type: "error"
            });

            console.log(error);
          }.bind(this)
        );
    }
  },
  deleteRow(index, rows) {
    rows.splice(index, 1);
  }
};
</script>

<style>

</style>
